import {
  PriceList,
  PriceListLine,
  Product,

  PriceApplicationLog,
  CustomerSelectionItem,
  ProductSelectionItem,
} from '@/types/pricing';

// Mock Products for pricing
export const mockProducts: Product[] = [
  {
    id: 'SERV001',
    code: 'SV001',
    name: 'Dịch vụ tư vấn thiết kế',
    categoryId: 'CAT001',
    categoryName: 'Tư vấn',
    basePrice: 450000,
    unit: 'giờ',
    status: 'active',
    isAvailableForPricing: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'SERV002',
    code: 'SV002',
    name: 'Dịch vụ lắp đặt nội thất',
    categoryId: 'CAT002',
    categoryName: 'Lắp đặt',
    basePrice: 750000,
    unit: 'ngày',
    status: 'active',
    isAvailableForPricing: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'SERV003',
    code: 'SV003',
    name: 'Dịch vụ bảo trì định kỳ',
    categoryId: 'CAT003',
    categoryName: 'Bảo trì',
    basePrice: 320000,
    unit: 'lần',
    status: 'active',
    isAvailableForPricing: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'SERV004',
    code: 'SV004',
    name: 'Dịch vụ sửa chữa khẩn cấp',
    categoryId: 'CAT003',
    categoryName: 'Bảo trì',
    basePrice: 380000,
    unit: 'giờ',
    status: 'active',
    isAvailableForPricing: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'SERV005',
    code: 'SV005',
    name: 'Dịch vụ vận chuyển',
    categoryId: 'CAT004',
    categoryName: 'Vận chuyển',
    basePrice: 85000,
    unit: 'km',
    status: 'active',
    isAvailableForPricing: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'SERV006',
    code: 'SV006',
    name: 'Dịch vụ đóng gói chuyên nghiệp',
    categoryId: 'CAT004',
    categoryName: 'Vận chuyển',
    basePrice: 125000,
    unit: 'kiện',
    status: 'active',
    isAvailableForPricing: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'SERV007',
    code: 'SV007',
    name: 'Dịch vụ đo đạc hiện trường',
    categoryId: 'CAT001',
    categoryName: 'Tư vấn',
    basePrice: 280000,
    unit: 'lần',
    status: 'active',
    isAvailableForPricing: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'PROD008',
    code: 'ST001',
    name: 'Đá granite',
    categoryId: 'CAT005',
    categoryName: 'Đá',
    basePrice: 550000,
    unit: 'm²',
    status: 'active',
    isAvailableForPricing: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
];

// Mock Price List Lines
export const mockPriceListLines: PriceListLine[] = [
  // Lines for "Bảng giá chung"
  {
    id: 'PLL001',
    priceListId: 'PL001',
    productId: 'SERV001',
    productCode: 'SV001',
    productName: 'Dịch vụ tư vấn thiết kế',
    basePrice: 450000,
    specialPrice: 420000,
    discountPercentage: 6.67,
    finalPrice: 420000,
    unit: 'giờ',
    isActive: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'PLL002',
    priceListId: 'PL001',
    productId: 'SERV002',
    productCode: 'SV002',
    productName: 'Dịch vụ lắp đặt nội thất',
    basePrice: 750000,
    specialPrice: 700000,
    discountPercentage: 6.67,
    finalPrice: 700000,
    unit: 'ngày',
    isActive: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'PLL003',
    priceListId: 'PL001',
    productId: 'SERV003',
    productCode: 'SV003',
    productName: 'Dịch vụ bảo trì định kỳ',
    basePrice: 320000,
    specialPrice: 300000,
    discountPercentage: 6.25,
    finalPrice: 300000,
    unit: 'lần',
    isActive: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },

  // Lines for "AC Thanh Loan - VIP"
  {
    id: 'PLL004',
    priceListId: 'PL002',
    productId: 'SERV001',
    productCode: 'SV001',
    productName: 'Dịch vụ tư vấn thiết kế',
    basePrice: 450000,
    specialPrice: 400000,
    discountPercentage: 11.11,
    finalPrice: 400000,
    unit: 'giờ',
    isActive: true,
    createdAt: '2024-01-20T09:00:00Z',
    updatedAt: '2024-01-20T09:00:00Z',
  },
  {
    id: 'PLL005',
    priceListId: 'PL002',
    productId: 'SERV002',
    productCode: 'SV002',
    productName: 'Dịch vụ lắp đặt nội thất',
    basePrice: 750000,
    specialPrice: 650000,
    discountPercentage: 13.33,
    finalPrice: 650000,
    unit: 'ngày',
    isActive: true,
    createdAt: '2024-01-20T09:00:00Z',
    updatedAt: '2024-01-20T09:00:00Z',
  },
  {
    id: 'PLL006',
    priceListId: 'PL002',
    productId: 'SERV005',
    productCode: 'SV005',
    productName: 'Dịch vụ vận chuyển',
    basePrice: 85000,
    specialPrice: 75000,
    discountPercentage: 11.76,
    finalPrice: 75000,
    unit: 'km',
    isActive: true,
    createdAt: '2024-01-20T09:00:00Z',
    updatedAt: '2024-01-20T09:00:00Z',
  },

  // Lines for "Baby Hạ Long - Khách sỉ"
  {
    id: 'PLL007',
    priceListId: 'PL003',
    productId: 'SERV003',
    productCode: 'SV003',
    productName: 'Dịch vụ bảo trì định kỳ',
    basePrice: 320000,
    specialPrice: 280000,
    discountPercentage: 12.5,
    finalPrice: 280000,
    unit: 'lần',
    minQuantity: 50,
    isActive: true,
    createdAt: '2024-02-01T10:00:00Z',
    updatedAt: '2024-02-01T10:00:00Z',
  },
  {
    id: 'PLL008',
    priceListId: 'PL003',
    productId: 'SERV004',
    productCode: 'SV004',
    productName: 'Dịch vụ sửa chữa khẩn cấp',
    basePrice: 380000,
    specialPrice: 330000,
    discountPercentage: 13.16,
    finalPrice: 330000,
    unit: 'giờ',
    minQuantity: 50,
    isActive: true,
    createdAt: '2024-02-01T10:00:00Z',
    updatedAt: '2024-02-01T10:00:00Z',
  },

  // Lines for "Khách hàng VIP" group
  {
    id: 'PLL009',
    priceListId: 'PL004',
    productId: 'SERV007',
    productCode: 'SV007',
    productName: 'Dịch vụ đo đạc hiện trường',
    basePrice: 280000,
    discountPercentage: 8,
    finalPrice: 257600,
    unit: 'lần',
    isActive: true,
    createdAt: '2024-02-15T11:00:00Z',
    updatedAt: '2024-02-15T11:00:00Z',
  },
  {
    id: 'PLL010',
    priceListId: 'PL004',
    productId: 'SERV008',
    productCode: 'SV008',
    productName: 'Dịch vụ thiết kế 3D',
    basePrice: 550000,
    discountPercentage: 8,
    finalPrice: 506000,
    unit: 'bản vẽ',
    isActive: true,
    createdAt: '2024-02-15T11:00:00Z',
    updatedAt: '2024-02-15T11:00:00Z',
  },
];

// Mock Price Lists
export const mockPriceLists: PriceList[] = [
  {
    id: 'PL001',
    code: 'BG-CHUNG-2024',
    name: 'Bảng giá chung',
    description: 'Bảng giá mặc định cho tất cả khách hàng',
    status: 'active',
    startDate: '2024-01-01T00:00:00Z',
    endDate: '2024-12-31T23:59:59Z',
    isDefault: true,
    priority: 999, // Lowest priority
    createdBy: 'admin',
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
    
    applicableCustomers: [], // Applies to all
    applicableCustomerGroups: [],
    
    priceListLines: mockPriceListLines.filter(line => line.priceListId === 'PL001'),
    
    totalProducts: 3,
    totalCustomers: 0, // All customers
    isActive: true,
  },
  {
    id: 'PL002',
    code: 'VIP-THANHLOAN-2024',
    name: 'AC Thanh Loan - VIP',
    description: 'Bảng giá đặc biệt cho khách hàng VIP Thanh Loan',
    status: 'active',
    startDate: '2024-01-20T00:00:00Z',
    endDate: '2024-06-30T23:59:59Z',
    isDefault: false,
    priority: 1, // High priority
    createdBy: 'admin',
    createdAt: '2024-01-20T09:00:00Z',
    updatedAt: '2024-01-20T09:00:00Z',

    applicableCustomers: ['CUST001'], // Specific customer
    applicableCustomerGroups: [],

    priceListLines: mockPriceListLines.filter(line => line.priceListId === 'PL002'),

    totalProducts: 3,
    totalCustomers: 1,
    isActive: true,
  },
  {
    id: 'PL003',
    code: 'SI-HALONG-2024',
    name: 'Baby Hạ Long - Khách sỉ',
    description: 'Bảng giá sỉ cho Baby Hạ Long (số lượng lớn)',
    status: 'active',
    startDate: '2024-02-01T00:00:00Z',
    isDefault: false,
    priority: 2,
    createdBy: 'admin',
    createdAt: '2024-02-01T10:00:00Z',
    updatedAt: '2024-02-01T10:00:00Z',

    applicableCustomers: ['CUST004'], // Specific customer
    applicableCustomerGroups: [],

    priceListLines: mockPriceListLines.filter(line => line.priceListId === 'PL003'),

    totalProducts: 2,
    totalCustomers: 1,
    isActive: true,
  },
  {
    id: 'PL004',
    code: 'GROUP-VIP-2024',
    name: 'Khách hàng VIP',
    description: 'Bảng giá cho nhóm khách hàng VIP',
    status: 'active',
    startDate: '2024-02-15T00:00:00Z',
    endDate: '2024-12-31T23:59:59Z',
    isDefault: false,
    priority: 5,
    createdBy: 'admin',
    createdAt: '2024-02-15T11:00:00Z',
    updatedAt: '2024-02-15T11:00:00Z',
    
    applicableCustomers: [],
    applicableCustomerGroups: ['CG001'], // VIP customer group
    
    pricingFormula: {
      type: 'percentage',
      baseValue: 100,
      operation: 'subtract',
      value: 8,
      roundingRule: 'round',
    },
    
    priceListLines: mockPriceListLines.filter(line => line.priceListId === 'PL004'),
    
    totalProducts: 2,
    totalCustomers: 0, // Group-based
    isActive: true,
  },
  {
    id: 'PL005',
    code: 'PROMO-SPRING-2024',
    name: 'Khuyến mãi mùa xuân 2024',
    description: 'Chương trình khuyến mãi đặc biệt mùa xuân',
    status: 'draft',
    startDate: '2024-03-01T00:00:00Z',
    endDate: '2024-05-31T23:59:59Z',
    isDefault: false,
    priority: 3,
    createdBy: 'admin',
    createdAt: '2024-02-25T14:00:00Z',
    updatedAt: '2024-02-25T14:00:00Z',

    applicableCustomers: [],
    applicableCustomerGroups: ['CG002'], // Regular customers

    priceListLines: [],

    totalProducts: 0,
    totalCustomers: 0,
    isActive: false,
  },
];

// Mock Customer Selection Items
export const mockCustomerSelectionItems: CustomerSelectionItem[] = [
  {
    id: 'CUST001',
    code: 'KH001',
    name: 'Nguyễn Văn Anh',
    type: 'individual',
    groupId: 'CG001',
    groupName: 'Khách hàng VIP',
    currentPriceListId: 'PL002',
    currentPriceListName: 'AC Thanh Loan - VIP',
    hasSpecialPricing: true,
  },
  {
    id: 'CUST002',
    code: 'KH002',
    name: 'Công ty TNHH ABC',
    type: 'company',
    groupId: 'CG001',
    groupName: 'Khách hàng VIP',
    hasSpecialPricing: false,
  },
  {
    id: 'CUST003',
    code: 'KH003',
    name: 'Trần Thị Bình',
    type: 'individual',
    groupId: 'CG002',
    groupName: 'Khách hàng thường',
    hasSpecialPricing: false,
  },
  {
    id: 'CUST004',
    code: 'KH004',
    name: 'Lê Minh Đức',
    type: 'individual',
    groupId: 'CG003',
    groupName: 'Khách hàng mới',
    currentPriceListId: 'PL003',
    currentPriceListName: 'Baby Hạ Long - Khách sỉ',
    hasSpecialPricing: true,
  },
  {
    id: 'CUST005',
    code: 'KH005',
    name: 'Công ty CP XYZ',
    type: 'company',
    groupId: 'CG002',
    groupName: 'Khách hàng thường',
    hasSpecialPricing: false,
  },
];

// Mock Product Selection Items
export const mockProductSelectionItems: ProductSelectionItem[] = [
  {
    id: 'SERV001',
    code: 'SV001',
    name: 'Dịch vụ tư vấn thiết kế',
    categoryName: 'Tư vấn',
    basePrice: 450000,
    unit: 'giờ',
    currentSpecialPrice: 400000,
    hasSpecialPricing: true,
    conflictingPriceLists: ['PL001', 'PL002'],
  },
  {
    id: 'SERV002',
    code: 'SV002',
    name: 'Dịch vụ lắp đặt nội thất',
    categoryName: 'Lắp đặt',
    basePrice: 750000,
    unit: 'ngày',
    currentSpecialPrice: 650000,
    hasSpecialPricing: true,
    conflictingPriceLists: ['PL001', 'PL002'],
  },
  {
    id: 'SERV003',
    code: 'SV003',
    name: 'Dịch vụ bảo trì định kỳ',
    categoryName: 'Bảo trì',
    basePrice: 320000,
    unit: 'lần',
    currentSpecialPrice: 280000,
    hasSpecialPricing: true,
    conflictingPriceLists: ['PL001', 'PL003'],
  },
  {
    id: 'SERV004',
    code: 'SV004',
    name: 'Dịch vụ sửa chữa khẩn cấp',
    categoryName: 'Bảo trì',
    basePrice: 380000,
    unit: 'giờ',
    currentSpecialPrice: 330000,
    hasSpecialPricing: true,
    conflictingPriceLists: ['PL003'],
  },
  {
    id: 'SERV005',
    code: 'SV005',
    name: 'Dịch vụ vận chuyển',
    categoryName: 'Vận chuyển',
    basePrice: 85000,
    unit: 'km',
    currentSpecialPrice: 75000,
    hasSpecialPricing: true,
    conflictingPriceLists: ['PL002'],
  },
  {
    id: 'SERV006',
    code: 'SV006',
    name: 'Dịch vụ đóng gói chuyên nghiệp',
    categoryName: 'Vận chuyển',
    basePrice: 125000,
    unit: 'kiện',
    hasSpecialPricing: false,
    conflictingPriceLists: [],
  },
  {
    id: 'SERV007',
    code: 'SV007',
    name: 'Dịch vụ đo đạc hiện trường',
    categoryName: 'Tư vấn',
    basePrice: 280000,
    unit: 'lần',
    currentSpecialPrice: 257600,
    hasSpecialPricing: true,
    conflictingPriceLists: ['PL004'],
  },
  {
    id: 'SERV008',
    code: 'SV008',
    name: 'Dịch vụ thiết kế 3D',
    categoryName: 'Tư vấn',
    basePrice: 550000,
    unit: 'bản vẽ',
    currentSpecialPrice: 506000,
    hasSpecialPricing: true,
    conflictingPriceLists: ['PL004'],
  },
];

// Mock Price Application Logs
export const mockPriceApplicationLogs: PriceApplicationLog[] = [
  {
    id: 'LOG001',
    customerId: 'CUST001',
    serviceId: 'SERV001',
    appliedPrice: 400000,
    priceSource: 'customer_specific',
    priceListId: 'PL002',
    timestamp: '2024-03-15T10:30:00Z',
    userId: 'USER001',
    notes: 'VIP customer special pricing applied',
  },
  {
    id: 'LOG002',
    customerId: 'CUST003',
    serviceId: 'SERV007',
    appliedPrice: 257600,
    priceSource: 'customer_group',
    priceListId: 'PL004',
    timestamp: '2024-03-15T11:15:00Z',
    userId: 'USER001',
    notes: 'VIP group discount applied',
  },
  {
    id: 'LOG003',
    customerId: 'CUST005',
    serviceId: 'SERV002',
    appliedPrice: 700000,
    priceSource: 'default',
    priceListId: 'PL001',
    timestamp: '2024-03-15T14:20:00Z',
    userId: 'USER002',
    notes: 'Default pricing applied',
  },
];

// Helper functions
export const generatePriceListCode = (): string => {
  const timestamp = Date.now().toString().slice(-6);
  return `BG-${timestamp}`;
};

export const generatePriceListLineId = (): string => {
  const nextNumber = mockPriceListLines.length + 1;
  return `PLL${String(nextNumber).padStart(3, '0')}`;
};

export const calculateFinalPrice = (
  basePrice: number,
  specialPrice?: number,
  discountPercentage?: number
): number => {
  if (specialPrice && specialPrice > 0) {
    return specialPrice;
  }
  
  if (discountPercentage && discountPercentage > 0) {
    return basePrice * (1 - discountPercentage / 100);
  }
  
  return basePrice;
};

export const getPriceListPriority = (priceList: PriceList): number => {
  // Customer-specific pricing has highest priority
  if (priceList.applicableCustomers.length > 0) {
    return 1;
  }
  
  // Customer group pricing has medium priority
  if (priceList.applicableCustomerGroups.length > 0) {
    return 5;
  }
  
  // Default pricing has lowest priority
  return 999;
};

// Mock categories for products
export const mockProductCategories = [
  { id: 'CAT001', name: 'Tư vấn' },
  { id: 'CAT002', name: 'Lắp đặt' },
  { id: 'CAT003', name: 'Bảo trì' },
  { id: 'CAT004', name: 'Vận chuyển' },
  { id: 'CAT005', name: 'Thiết kế' },
];

// Interface for dynamic price columns
interface DynamicPriceColumn {
  key: string;
  title: string;
  type: 'customer' | 'group';
  id: string;
}

// Get dynamic table columns based on selected customers/groups
export const getDynamicPriceColumns = (
  selectedCustomers: string[] = [],
  selectedGroups: string[] = []
): DynamicPriceColumn[] => {
  const columns: DynamicPriceColumn[] = [];
  
  // Add customer-specific columns
  selectedCustomers.forEach(customerId => {
    const customer = mockCustomerSelectionItems.find(c => c.id === customerId);
    if (customer) {
      columns.push({
        key: `customer_${customerId}`,
        title: customer.name,
        type: 'customer',
        id: customerId,
      });
    }
  });
  
  // Add group-specific columns
  selectedGroups.forEach(groupId => {
    // This would typically come from customer groups API
    const groupName = groupId === 'CG001' ? 'Khách hàng VIP' : 
                     groupId === 'CG002' ? 'Khách hàng thường' : 
                     'Khách hàng mới';
    columns.push({
      key: `group_${groupId}`,
      title: groupName,
      type: 'group',
      id: groupId,
    });
  });
  
  return columns;
}; 